import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { FormData, IFormError, IReport } from '../models';
import { ReportTemplate } from '../components/templates/ReportTemplate';
import useApi from '../hooks/use-api';
import { useDispatch, useSelector } from 'react-redux';
import { selectReport, setReporter } from '../redux/report-slice';
import { setErrors, setFormData } from '../redux/form-data-slice';
import { t } from 'i18next';

function ReportPage() {
	const navigate = useNavigate();
	const { http } = useApi();
	const dispatch = useDispatch();

	const report = useSelector(selectReport);

	useEffect(() => {
		const loadData = async () => {
			const response = await http('GET', `FormData`);
			const data = FormData.parse(response?.data);
			dispatch(setFormData(data));
			dispatch(setReporter(data.userInfo));
		};
		loadData();
	}, [http, dispatch]);

	const validate = useCallback((report: IReport) => {
		const errors:IFormError[] = [];

		if(!report.responsible) {
			errors.push({key:'responsible', message:t('error.required')});
		}

		if (
			`${report.reporter.firstname} ${report.reporter.lastname}` === '' ||
			report.reporter.phone === '' ||
			report.reporter.email === '' ||
			report.reporter.department === ''
		) {
			errors.push({key:'reporter', message:t('error.required')});
		}

		if(!report.description) {
			errors.push({key:'description', message:t('error.required')})
		}

		if(!report.affectedPersons) {
			errors.push({key:'affectedPersons', message:t('error.required')})
		}

		if(!report.affectedData) {
			errors.push({key:'affectedData', message:t('error.required')})
		}

		if(!report.recognition) {
			errors.push({key:'recognition', message:t('error.required')});
		}

 		if (report.occurrence && report.recognition && report.recognition < report.occurrence) {
			errors.push({key:'recognition', message:t('error.detectionBeforeOccurence')});
		}

		console.log(errors);
		dispatch(setErrors(errors));

		return errors.length === 0;
	}, [dispatch]);

	const onSave = useCallback(async () => {
		const isValid = validate(report);

		if(isValid) {
			await http('POST', `SaveReport`, {
				...report,
				occurrence: report.occurrence ? new Date(report.occurrence) : undefined, 
				recognition: report.recognition ? new Date(report.recognition) : undefined, 
			});
			navigate('/confirmation');
		}
	}, [http, navigate, report, validate]);

	return (
		<ReportTemplate
			onSave={onSave}
			onHome={() => navigate('/')}
		/>
	);
}

export default ReportPage;
